"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Svg = exports.Link = exports.ImageWrapper = exports.ImageContainer = exports.Image = exports.Credits = exports.Content = exports.ContainerCredits = exports.Container = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const setImagePosition = position => {
  switch (position) {
    case 'top':
      return (0, _styledComponents.css)`
        top: 0;
      `;
    case 'center':
      return (0, _styledComponents.css)`
        top: 25%;
      `;
    case 'bottom':
      return (0, _styledComponents.css)`
        bottom: 0;
      `;
    default:
      return;
  }
};
const setImageAlignment = alignment => {
  switch (alignment) {
    case 'left':
      return (0, _styledComponents.css)`
        left: 0;
      `;
    case 'center':
      return (0, _styledComponents.css)`
        left: 30%;
        right: 30%;
      `;
    case 'right':
      return (0, _styledComponents.css)`
        right: 0;
      `;
    default:
      return;
  }
};
const setZIndex = index => {
  return (0, _styledComponents.css)`
    z-index: ${index + 1};
  `;
};
const overlayVertical = position => {
  switch (position) {
    case 'top':
      return (0, _styledComponents.css)`
        align-items: flex-start;
      `;
    case 'center':
      return (0, _styledComponents.css)`
        align-items: center;
      `;
    case 'bottom':
      return (0, _styledComponents.css)`
        align-items: flex-end;
      `;
    default:
      return;
  }
};
const setLayout = type => {
  switch (type) {
    case 'standard':
      return (0, _styledComponents.css)`
        @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
          margin: 0px -8px;
          display: flex;
          align-items: flex-start;
          justify-content: center;
        }
      `;
    case 'overlay':
      return (0, _styledComponents.css)`
        min-height: 200vh;
        height: 100%;
        width: 100%;
        position: relative;
        @media (max-width: ${_breakpoints.BREAKPOINTS.md}px) {
          ${(0, _layout.setContainer)({
        size: 'lg'
      })}
          min-height: 100vh;
          flex-direction: column;
          align-items: center;
          display: flex;
          justify-content: center;
        }
      `;
    default:
      return (0, _styledComponents.css)`
        @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
          margin: 0px -8px;
          display: flex;
          align-items: flex-start;
        }
      `;
  }
};
const Container = _styledComponents.default.div`
  ${props => (0, _layout.setContainer)({
  size: props.useContainer ? 'lg' : 'xl'
})}

  ${props => !props.usePadding && 'padding: 0px!important;'}
`;
exports.Container = Container;
const ImageWrapper = _styledComponents.default.div`
  position: relative;
  will-change: transform;
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    margin-bottom: 16px;
  }
  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    object-fit: cover;
    margin: 0px 8px;
  }
  ${props => props.overlay && (0, _styledComponents.css)`
      ${props => setImagePosition(props.position)};
      ${props => setImageAlignment(props.alignment)};
      ${props => setZIndex(props.index)};
      width: ${props => `calc(${90 * props.aspectRatio}vh - ${90 * props.aspectRatio}px);`};
      position: absolute;
      will-change: transform;
      @media (max-width: ${_breakpoints.BREAKPOINTS.md}px) {
        position: unset;
      }
    `};
  &.animation-transform,
  & > div {
    will-change: transform;
  }
`;
exports.ImageWrapper = ImageWrapper;
const Link = _styledComponents.default.a`
  transition: 0.2s filter;
  filter: brightness(1);
  &:hover {
    filter: brightness(0.7);
  }
`;
exports.Link = Link;
const ImageContainer = _styledComponents.default.div`
  position: relative;
  display: flex;
  ${props => overlayVertical(props.svgPosition)};
`;
exports.ImageContainer = ImageContainer;
const Content = _styledComponents.default.div`
  ${props => setLayout(props.type)};
`;
exports.Content = Content;
const Image = _styledComponents.default.img`
  width: 100%;
  max-width: 100%;
  display: block;
  ${props => props.showOnlyOnDesktop && `
    @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
      display: none;
    }
  `}
  ${props => props.mobile && `
    width: 100%;
    @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
      display: none;
    }
  `}
`;
exports.Image = Image;
const Svg = _styledComponents.default.img`
  position: absolute;
  max-width: 100%;
`;
exports.Svg = Svg;
const ContainerCredits = _styledComponents.default.div`
  display: flex;
  justify-content: ${props => props.align};
  padding-left: ${props => props.padding === 'left' || props.padding === 'both' ? '20px' : 0};
  padding-right: ${props => props.padding === 'right' || props.padding === 'both' ? '20px' : 0};
`;
exports.ContainerCredits = ContainerCredits;
const Credits = _styledComponents.default.p`
  color: ${props => props.creditsColor};
  font-size: 13px;
  margin: 5px 0 0;
  ${(0, _typography.setFont)({
  bold: false
})}
`;
exports.Credits = Credits;
//# sourceMappingURL=styles.js.map